/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// require('./bootstrap');

document.addEventListener("DOMContentLoaded", () => {
    // INSTAGRAM !!!

    const limitWidth = 8;

    if ($(window).width() <= 560) {
        const limitWidth = 4;
    }

    // NAVIGATION TOP !!!

    const navigationtop = new Navigation(
        document.getElementById("navigationtop"),
        {
            breakpoint: 1199
        }
    );
});
// Website Cookie -----------------------
// ----------------------------------------
// setThisCookie()

var tnaSetThisCookie = function (name, days) {
    const d = new Date();
    d.setTime(d.getTime() + 1000 * 60 * 60 * 24 * days);
    document.cookie = `${name}=true;path=/;expires=${d.toGMTString()};`;
};
// checkForThisCookie()
var tnaCheckForThisCookie = function (name) {
    if (document.cookie.indexOf(name) === -1) {
        return false;
    }
    return true;
};

// Cookie notification
$(() => {
    // All content must be placed within this IIFE.
    $("#mega-menu-pull-down").show();
    if (!tnaCheckForThisCookie("dontShowCookieNotice")) {
        $(`<div class="cookieNotice">${window.cookieNotification}</div>`)
            .css({
                padding: "5px",
                "text-align": "center",
                backgroundColor: "#a3aaae",
                color: "#2a3942",
                position: "fixed",
                bottom: 0,
                "font-size": "14px",
                width: "100%",
                display: "none"
            })
            .appendTo("body");

        setTimeout(() => {
            $(".cookieNotice").slideDown(1000);
        }, 1000);
    }
});

// Binding to document (event delegation)
$(document).on("click", "#cookieCutter", e => {
    e.preventDefault();
    tnaSetThisCookie("dontShowCookieNotice", 365);
    $(".cookieNotice").hide();
});
// ----------------------------------------
document.addEventListener("DOMContentLoaded", event => {
    const lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy",
        thresholds: "0px",
    });

    // NAVIGATION !!!

    const navigation = new Navigation(document.getElementById("navigation"), {
        breakpoint: 1199,
    });

    // const observer = load();
    // observer.observe();

    // PROJECTS

    const btn = $("#button");

    $(window).scroll(() => {
        if ($(window).scrollTop() > 300) {
            btn.addClass("show");
        } else {
            btn.removeClass("show");
        }
    });

    btn.on("click", e => {
        e.preventDefault();
        $("html, body").animate(
            {
                scrollTop: 0
            },
            "300"
        );
    });
});

$(document).ready(() => {
    $("#colours .color-thumb").click(function (e) {
        e.preventDefault();

        let imgSrc = $(this).data("src");
        let button = $(this);
        $("#colours .image-loader").removeClass("d-none");
        $("#colorsMainImage")
            .on("load", function () {
                $("#colours .color-thumb.active").removeClass("active");
                button.addClass("active");
                $("#colours .image-loader").addClass("d-none");
            })
            .attr("src", imgSrc);
    });
});
window.addEventListener('load', (event) => {
    console.log("load");
    if ($.fn.revolution) {
        jQuery("#rev_slider_1")
            .show()
            .revolution({
                /* options are 'auto', 'fullwidth' or 'fullscreen' */
                sliderLayout: "fullWidth",
                autoHeight: "on",
                delay: 5000,
                lazyType: "all",
                // stopLoop: "on",
                // stopAfterLoops: 0,
                // stopAtSlide: 1,

                jsFileLocation: "/js/revolution/",

                responsiveLevels: [1920, 1600, 1240, 1024, 778, 480],
                /* [DESKTOP, LAPTOP, TABLET, SMARTPHONE] */
                gridwidth: [1920, 1600, 1240, 1024, 778, 480],
                /* [DESKTOP, LAPTOP, TABLET, SMARTPHONE] */
                gridheight: [800, 800, 800, 768, 600, 480],

                visibilityLevels: [1920, 1600, 1240, 1024, 1024, 480],

                /* basic navigation arrows and bullets */
                navigation: {
                    arrows: {
                        enable: true,
                        style: "hades",
                        hide_onleave: false
                    },

                    bullets: {
                        enable: true,
                        style: "uranus",
                        tmp: '<span class="tp-bullet-inner"></span>',
                        hide_onleave: false,
                        h_align: "center",
                        v_align: "bottom",
                        h_offset: 0,
                        v_offset: 20,
                        space: 5
                    }
                }
            });
        console.log("brand call");
        /* initialize the slider based on the Slider's ID attribute */
        jQuery("#brand_movie")
            .show()
            .revolution({
                /* options are 'auto', 'fullwidth' or 'fullscreen' */
                sliderLayout: "fullWidth",
                autoHeight: "on",
                // delay: 5000,
                // stopLoop: "on",
                // stopAfterLoops: 0,
                // stopAtSlide: 1,

                jsFileLocation: "/js/revolution/",

                responsiveLevels: [1920, 1600, 1240, 1024, 778, 480],
                /* [DESKTOP, LAPTOP, TABLET, SMARTPHONE] */
                gridwidth: [1920, 1600, 1240, 1024, 778, 480],
                /* [DESKTOP, LAPTOP, TABLET, SMARTPHONE] */
                gridheight: [1076, 896, 694, 576, 435, 266],
                visibilityLevels: [1920, 1600, 1240, 1024, 1024, 266]
            });
        jQuery("#phoenix_movie")
            .show()
            .revolution({
                /* options are 'auto', 'fullwidth' or 'fullscreen' */
                sliderLayout: "fullWidth",
                autoHeight: "on",
                // delay: 5000,
                // stopLoop: "on",
                // stopAfterLoops: 0,
                // stopAtSlide: 1,

                jsFileLocation: "/js/revolution/",

                responsiveLevels: [1920, 1600, 1240, 1024, 778, 480],
                /* [DESKTOP, LAPTOP, TABLET, SMARTPHONE] */
                gridwidth: [1920, 1600, 1240, 1024, 778, 480],
                /* [DESKTOP, LAPTOP, TABLET, SMARTPHONE] */
                gridheight: [1076, 896, 694, 576, 435, 266],
                visibilityLevels: [1920, 1600, 1240, 1024, 1024, 266]
            });

        jQuery("#gama_intro")
            .show()
            .revolution({
                /* options are 'auto', 'fullwidth' or 'fullscreen' */
                sliderLayout: "fullWidth",
                autoHeight: "on",
                lazyType: "all",
                // delay: 5000,
                // stopLoop: "on",
                // stopAfterLoops: 0,
                // stopAtSlide: 1,

                jsFileLocation: "/js/revolution/",

                responsiveLevels: [1920, 1600, 1240, 1024, 778, 480],
                /* [DESKTOP, LAPTOP, TABLET, SMARTPHONE] */
                gridwidth: [1920, 1600, 1240, 1024, 778, 480],
                /* [DESKTOP, LAPTOP, TABLET, SMARTPHONE] */
                gridheight: [600, 600, 600, 768, 600, 480],
                visibilityLevels: [1920, 1600, 1240, 1024, 1024, 480]
            });
        jQuery("#virtual_tour")
            .show()
            .revolution({
                /* options are 'auto', 'fullwidth' or 'fullscreen' */
                sliderLayout: "fullWidth",
                autoHeight: "on",
                // delay: 5000,
                // stopLoop: "on",
                // stopAfterLoops: 0,
                // stopAtSlide: 1,

                jsFileLocation: "/js/revolution/",
                lazyType: "all"

                // responsiveLevels: [1920, 1600, 1240, 1024, 778, 480],
                // /* [DESKTOP, LAPTOP, TABLET, SMARTPHONE] */
                // gridwidth: [1920, 1600, 1240, 1024, 778, 480],
                // /* [DESKTOP, LAPTOP, TABLET, SMARTPHONE] */
                // // gridheight: [600, 600, 600, 768, 600, 480],
                // visibilityLevels: [1920, 1600, 1240, 1024, 1024, 480],
            });
        jQuery("#gamaproject")
            .show()
            .revolution({
                /* options are 'auto', 'fullwidth' or 'fullscreen' */
                sliderLayout: "fullWidth",
                autoHeight: "on",
                delay: 5000,
                // stopLoop: "on",
                // stopAfterLoops: 0,
                // stopAtSlide: 1,

                jsFileLocation: "/js/revolution/",
                lazyType: "all",

                responsiveLevels: [1920, 1600, 1240, 1024, 778, 480],
                /* [DESKTOP, LAPTOP, TABLET, SMARTPHONE] */
                gridwidth: [1920, 1600, 1240, 1024, 778, 480],
                /* [DESKTOP, LAPTOP, TABLET, SMARTPHONE] */
                gridheight: [600, 600, 600, 768, 600, 480],

                visibilityLevels: [1920, 1600, 1240, 1024, 1024, 480],

                /* basic navigation arrows and bullets */
                navigation: {
                    arrows: {
                        enable: true,
                        style: "hades",
                        hide_onleave: false
                    },

                    bullets: {
                        enable: true,
                        style: "uranus",
                        tmp: '<span class="tp-bullet-inner"></span>',
                        hide_onleave: false,
                        h_align: "center",
                        v_align: "bottom",
                        h_offset: 0,
                        v_offset: 20,
                        space: 5
                    }
                }
            });

    }
});
jQuery(document).ready(() => {
    console.log("ready");
    $(".modal").on("hide.bs.modal", event => {
        $(".hotspots .button.active").removeClass("active");
    });
    $('a[href^="#info"]').on("click", function (event) {
        var target = $(this.getAttribute("href"));
        if (target.length) {
            event.preventDefault();
            $("html, body")
                .stop()
                .animate(
                    {
                        scrollTop: target.offset().top
                    },
                    1000
                );
        }
    });
    $(".hotspots .button").click(function () {
        $(this)
            .closest(".hotspots")
            .find(".button.active")
            .removeClass("active");
        $(this).addClass("active");
    });

    if ($("#furnishingsMainImage").length > 0) {
        $("#furnishingsMainImage").attr(
            "src",
            $("#furnishings .color-thumb")
                .first()
                .data("src")
        );
        $("#furnishings .color-thumb").click(function (e) {
            e.preventDefault();

            const imgSrc = $(this).data("src");
            const button = $(this);
            $("#furnishings .image-loader").removeClass("d-none");
            $("#furnishingsMainImage")
                .on("load", () => {
                    $("#furnishings .color-thumb.active").removeClass("active");
                    button.addClass("active");
                    $("#furnishings .image-loader").addClass("d-none");
                })
                .attr("src", imgSrc);
        });
    }

    if ($(".center").length > 0) {
        $(".center").slick({
            nextArrow: '<i class="tp-rightarrow tparrows hades"></i>',
            prevArrow: '<i class="tp-leftarrow tparrows hades"></i>',
            centerMode: true,
            centerPadding: "60px",
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: true,
                        centerMode: true,
                        centerPadding: "40px",
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: true,
                        centerMode: true,
                        centerPadding: "40px",
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    jQuery(".rev_slider .rev-slidebg").each(function () {
        const breakpoint = 992;
        const $this = jQuery(this);

        // if the screen width is less than or equal to the breakpoint, use the mobile image
        if (jQuery(window).width() <= breakpoint) {
            $this.attr("data-lazyload", $this.attr("data-mobile"));
        }
        // if the screen width is greater than the breakpoint, use the desktop image
        else {
            $this.attr("data-lazyload", $this.attr("data-desktop"));
        }
    });

    // if ($('.slick-slider').length > 0) {
    //     $('.slick-slider').slick({
    //         slidesToShow: 3,
    //         slidesToScroll: 1,
    //     });
    // }

    $(() => {
        $('[data-toggle="tooltip"]').tooltip();
    });



    (function () {
        // define variables
        const items = document.querySelectorAll(".timeline li");

        // check if an element is in viewport
        // http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
        function isElementInViewport(el) {
            const rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <=
                (window.innerHeight ||
                    document.documentElement.clientHeight) &&
                rect.right <=
                (window.innerWidth || document.documentElement.clientWidth)
            );
        }

        function callbackFunc() {
            for (let i = 0; i < items.length; i++) {
                if (isElementInViewport(items[i])) {
                    items[i].classList.add("in-view");
                }
            }
        }

        // listen for events
        window.addEventListener("load", callbackFunc);
        window.addEventListener("resize", callbackFunc);
        window.addEventListener("scroll", callbackFunc);
    })();
    $("#left").click(() => {
        $(".transform1").toggleClass("transform-left");
        $(".button1").toggleClass("button-red");
    });
    $("#right").click(() => {
        $(".transform2").toggleClass("transform-right");
        $(".button2").toggleClass("button-red");
    });

});
